import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import photo1 from "../assets/img/photo1.jpg";
import photo2 from "../assets/img/photo2.jpg";
import photo3 from "../assets/img/photo3.jpg";
import photo4 from "../assets/img/photo4.jpg";
import portrait1 from "../assets/img/portrait1.jpeg";
import portrait2 from "../assets/img/portrait2.jpeg";
import portrait3 from "../assets/img/portrait3.jpeg";
import portrait4 from "../assets/img/portrait4.jpeg";

const MarqueeGallery = () => {
  const marqueeRef = useRef(null);

  // Create array of images for the marquee effect
  const marqueeImages = [
    { src: photo1, alt: "Church Photo 1", type: "landscape" },
    { src: portrait1, alt: "church Photo 1", type: "portrait" },
    { src: photo2, alt: "Church Photo 2", type: "landscape" },
    { src: portrait2, alt: "church Photo 2", type: "portrait" },
    { src: photo3, alt: "Church Photo 3", type: "landscape" },
    { src: portrait3, alt: "church Photo 3", type: "portrait" },
    { src: photo4, alt: "Church Photo 4", type: "landscape" },
    { src: photo1, alt: "Church Photo 1", type: "landscape" },
    { src: portrait4, alt: "church Photo 4", type: "portrait" },
    { src: photo2, alt: "Church Photo 2", type: "landscape" },
    { src: photo3, alt: "Church Photo 3", type: "landscape" },
    { src: photo4, alt: "Church Photo 4", type: "landscape" },
  ];

  useEffect(() => {
    // GSAP animations for smooth marquee effect
    const marquee = marqueeRef.current;

    if (marquee) {
      // Single row animation (left to right)
      gsap.to(marquee, {
        x: "-50%",
        repeat: -1,
        duration: 200,
      });

      // Pause on hover
      // const container = marquee.parentElement;
      // if (container) {
      //   container.addEventListener("mouseenter", () => {
      //     gsap.getTweensOf(marquee)[0]?.pause();
      //   });

      //   container.addEventListener("mouseleave", () => {
      //     gsap.getTweensOf(marquee)[0]?.resume();
      //   });
      // }
    }

    // Cleanup
    return () => {
      gsap.killTweensOf(marquee);
    };
  }, []);

  return (
    <div
      className="relative w-full overflow-hidden bg-gray-50"
      style={{ height: "100%" }}
    >
      {/* Single row - moves left */}
      <div className="marquee-container" style={{ height: "100%" }}>
        <div
          ref={marqueeRef}
          className="marquee-track flex"
          style={{ width: "max-content" }}
        >
          {marqueeImages.map((image, index) => (
            <div key={`marquee-${index}`} className="marquee-item">
              <img
                src={image.src}
                alt={image.alt}
                className="object-cover shadow-sm"
                style={{
                  margin: "0 2rem",
                  borderRadius: "8px",
                  width: "479px",
                  height: "100%",
                  aspectRatio: image.type === "landscape" ? "16 / 9" : "auto",
                }}
              />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {marqueeImages.map((image, index) => (
            <div key={`marquee-duplicate-${index}`} className="marquee-item">
              <img
                src={image.src}
                alt={image.alt}
                className="object-cover shadow-sm"
                style={{
                  margin: "0 2rem",
                  borderRadius: "20px",
                  width: "479px",
                  height: "100%",
                  aspectRatio: image.type === "landscape" ? "16 / 9" : "auto",
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Gradient overlays for smooth fade effect */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-gray-50 to-transparent"></div>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 to-transparent"></div>

      <style jsx>{`
        .marquee-container {
          width: 100%;
          overflow: hidden;
          position: relative;
          display: flex;
          align-items: center;
        }

        .marquee-track {
          display: flex;
          align-items: center;
        }

        .marquee-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .marquee-item img {
            margin: 0 1rem !important;
            width: 300px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default MarqueeGallery;
